import { render } from "./HoldOprettelseKvittering.vue?vue&type=template&id=9d363998"
import script from "./HoldOprettelseKvittering.vue?vue&type=script&lang=js"
export * from "./HoldOprettelseKvittering.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__